export const PMM_ADVANCED_SETTINGS_URL = '/settings/advanced-settings';
